module.exports = __webpack_public_path__ + "images/emoji/smoking.24349e8954f6bcf190ef.png";